<template>
  <div>
    <v-form @submit.prevent="submitResponse">
      <p class="mb-2">
        In your lab discussion last week there was a problem at a company's warehouse, and you were
        being retained to help fix the problem. Restate, in your own words, what the problem was.
      </p>

      <p class="mb-n2">
        <s-textarea v-model="inputs.studentAnswer" outlined />
      </p>
    </v-form>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';
import STextarea from '@/common/components/STextarea.vue';

export default {
  name: 'OleMiss116_PL9_Q2part1',
  components: {STextarea},
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        studentAnswer: null,
      },
    };
  },
};
</script>
